jQuery(document).ready(function ($) {
    var $window = $(window),
	html = $("html"),
	body = $("body"),
	header = $("header"),
	article = $("article"),
	footer = $("footer");
    ({
        init: function () {
            this.get_lazy(), 
            this.xs_menu_toggle(), 
            this.scroll_shrink(), 
            this.popup_toggle(), 
            this.scrollto(), 
            this.get_csselect(), 
            this.get_image_background(), 
            this.page_min_height(), 
            this.padding_top_head(), 
            this.text_lettering();
            this.toggle_product_list();
            this.collection_slider();
            this.get_action_share();
            this.load(), 
            this.resize(), 
            this.overlay_load()
            
        },
        overlay_load: function () {
            $("#overlay-load").fadeOut()
        },
        get_lazy: function () {
            if($(".lazy").length){
                $(".lazy").lazy()
            }
            
        },
        xs_menu_toggle: function () {
            var t = $(".xs-head-bars"),
                i = $(".xs-head-toggle");
            t.click(function () {
                t.toggleClass("active"), i.toggleClass("open")
            })
        },
        text_lettering: function() {
            if($(".text-lettering").length){
                $(".text-lettering").lettering();
            }
            
        },
        padding_top_head: function () {
            var t = $(".padding-top-head"),
                i = header.outerHeight();
            t.css("padding-top", i)
        },
        scroll_shrink: function () {
            var t = this;
                $window.height();
                $(window).scroll(function () {
                    var i = window.pageYOffset;
                    i >= 600 ? body.addClass("shrink-2") : body.removeClass("shrink-2");
                    i >= 300 ? body.addClass("shrink") : body.removeClass("shrink");
                    // 0 == i && setTimeout(function () {
                    //     t.padding_top_head()
                    // }, 400)
                })
            
        },
        scrollto: function () {
            $(".scrollto").click(function () {
                var t = $(this).attr("data-pos");
                if (void 0 === t) {
                    var i = $(this).attr("data-id");
                    $("#" + i).length && $("html,body").animate({
                        scrollTop: $("#" + i).offset().top
                    }, 500)
                } else "" != t && $("html,body").animate({
                    scrollTop: parseInt(t)
                }, 500);
                return !1
            }), $('a[href^="#"]').click(function () {
                var t = $(this).attr("href");
                if ($(t).length) return $("html,body").animate({
                    scrollTop: $(t).offset().top
                }, 500), !1
            })
        },
        popup_toggle: function () {
            $(".toggle-pop").click(function () {
                var t = $(this).attr("data-pop"),
                    i = $("#" + t);
                $(this).toggleClass("active"), i.each(function () {
                    "fade" == $(this).attr("data-action") ? $(this).fadeToggle() : "slide" == $(this).attr("data-action") && $(this).stop(!0, !0).slideToggle(), $(this).toggleClass("active")
                });
                i.find('input').focus();
                return false;
            })
        },
        get_image_background: function () {
            $(".background").each(function () {
                var t = $(this).find("img");
                if (t.length) {
                    var i = t.attr("src");
                    $(this).css("background-image", "url(" + i + ")")
                }
            })
        },
        page_min_height: function () {
            var t = $window.height(),
                i = footer.outerHeight();
            article.css("min-height", t - i)
        },
        get_csselect: function () {
            var t = $("select.cs-select");

            function i() {
                [].slice.call(document.querySelectorAll(".cs-select")).forEach(function (t) {
                    new SelectFx(t, {
                        onChange: function (i) {
                            t.classList.contains("cs-redirect") && (window.location = i)
                        }
                    })
                })
            }
            $("select.cs-select.cs-select-wload").length ? $window.load(function () {
                i()
            }) : t.length && i()
        },
        get_istope: function () {
            $(".col-list--isotope").isotope({
                filter: "*",
                animationOptions: {
                    duration: 750,
                    easing: "linear",
                    queue: !1
                }
            })
        },
        toggle_product_list:function(){
            var section = $('.product-list-toggle');
            var nav = section.find('.nav-item');
            var content = section.find('.content-toggle-item');
            nav.click(function(){
                var index = $(this).index();
                var parents = $(this).parents('.product-list-toggle');
                if(!$(this).hasClass('active')){
                    parents.find('.nav-item').removeClass('active');
                    $(this).addClass('active');
                    parents.find('.content-toggle-item').slideUp();
                    parents.find('.content-toggle-item').eq(index).slideDown();
                }
            })
        },
        collection_slider: function () {
            var $lightSlider = $('.section-collection-list-slider .collection-list-box .card-list');
            $lightSlider.removeClass('row');
            var slider = $lightSlider.lightSlider({
                item: 5,
                loop: true,
                slideMove: 2,
                easing: 'cubic-bezier(0.25, 0, 0.25, 1)',
                speed: 1200,
                pager: false,
                auto: false,
                pause: 5200,
                slideMargin: 0,
                responsive: [{
                        breakpoint: 992,
                        settings: {
                            item: 4,
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            item: 3,
                        }
                    },
                    {
                        breakpoint: 575,
                        settings: {
                            item: 2,
                        }
                    }
                ]
            });
        },
        get_action_share: function() {
            var self = this;
            var _this = {
                button_click: function() {
                    var btn = $(".js-social-share");
                    btn.click(function() {
                        self.windowPopup($(this).attr("href"), 500, 500);
                        return false;
                    })
                },

            }
            _this.button_click();
        },
        windowPopup: function(url, width, height) {
            var left = (window.screen.availLeft + (window.screen.availWidth / 2)) - (width / 2);
            var top = (window.screen.availTop + (window.screen.availHeight / 2)) - (height / 2);
            window.open(url, "", "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=" + width + ",height=" + height + ",top=" + top + ",left=" + left);
        },
        load: function () {
            var t = this;
            $window.load(function () {
                t.padding_top_head(), t.page_min_height(), $("*[data-enllax-type]").length && $window.width() > 767 && $(window).enllax()
            })
        },
        resize: function () {
            var t = this;
            $window.resize(function () {
                t.page_min_height()
            })
        }
    }).init()
});